export default "__VITE_ASSET__DRgETDYP__"